module.exports = __webpack_public_path__ + "img/fk.3c219c64.svg";